<template>
    <span class="top-rank-badge">{{ text }}</span>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  text: {
    type: String,
    default: 'TOP1'
  }
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.top-rank-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    padding: 0 0.15rem;
    height: 0.44rem;
    border-radius: 0.04rem;
    line-height: 0.34rem;

    color: #ff6200;
    font-size: 0.22rem;
    font-weight: 600;

    background-color: rgba(255, 105, 0, 0.2);
}
</style>
